module.exports = __webpack_public_path__ + "static/media/survey1_2.64b8ab1b.png";